import React, { FC, useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    Checkbox,
    Tabs,
    Tab,
    Box,
    TextField,
    Autocomplete,
    Snackbar,
    Alert,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableBody,
    TableRow,
    InputAdornment,
    Tooltip,
    IconButton,
    Paper,
    Card,
    Chip,
} from "@mui/material";
import { Campaign, Search, CheckCircle } from "@mui/icons-material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { Drawer, Divider, List, ListItem, ListItemText } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useTicketStore } from "../../hooks/useTicketStore";
import { useUbigeoStore } from "../../hooks/useUbigeoStore";
import { Supplier } from "../../types/slices/supplierType";
import { useSupplierStore } from "../../hooks/useSupplierStore";
import SearchIcon from '@mui/icons-material/Search';
import { ApiStatus } from "../../types/api/status";
import { useSoftnetStore } from "../../hooks/useSoftnetStore";
import { Console } from "console";
import { TicketAPI } from "../../apis/TicketAPI";
import HelpIcon from '@mui/icons-material/Help';
import { useDriverStore } from "../../hooks/useDriverStore";
import { usePatentStore } from "../../hooks/usePatentStore";
import { driver } from "../../types/slices/driverType";
import { patent } from "../../types/slices/patentType";
import { DrawerDispatchGuides } from "./components/drawers/DrawerDispatchGuides";
import { DrawerInvoiceRoute } from "./components/drawers/DrawerInvoiceRoute";
import { Route, Ticket } from "../../types/slices/ticketType";
import SendIcon from '@mui/icons-material/Send';
import DescriptionIcon from '@mui/icons-material/Description';
import { moneyCL } from "../../toolbox/helpers/money-helpers";
import moment from "moment";
import { IssueDrawer } from "./components/drawers/IssueDrawer";
import { useAuthStore } from "../../hooks/useAuthStore";
import { TrackerTicketDrawer } from "./components/drawers/TrackerTicketDrawer";
interface Product {
    name: string;
    quantity: number;
    price: number;
}

interface OrderRow {
    id: number;
    date: string;
    type_document: string;
    customer: string;
    net_total: number;
    total_discount: number;
    IVA: number;
    total: number;
    district: string;
    address: string;
    status: "pedido" | "facturado" | "ruta";
    n_ruta?: number;
    folio?: number;
    products: Product[];
}

interface ProcessOrder {
    ticket: Ticket;
    nInterno: string;
    ordenCompra: string;
    references: Reference[];
}

interface Reference {
    type: string;
    date: string;
    folio: string;
    reason?: string;
}

const tabs = [
    { value: "pedido", color: "purple", icon: <Campaign />, label: "Pedidos" },
    { value: "facturado", color: "orange", icon: <Search />, label: "Facturación" },
    { value: "ruta", color: "green", icon: <CheckCircle />, label: "En Ruta" },
];

const localDate = moment().format("YYYY-MM-DDTHH:mm");

export const ClientOrderList: FC = () => {
    const { user } = useAuthStore()
    const { getTicket, tickets: pedidos, getRoutes, createRoute, createRelationTicket, setSelectedRoute, routeSelected } = useTicketStore();
    const { getDistricts, districts } = useUbigeoStore();
    const { status, createSalesDocument } = useSoftnetStore()
    const { getDrivers, drivers, driverSelected, setSelectedDriver, status: statusDriver } = useDriverStore();
    const { getPatents, patents, patentSelected, setSelectedPatent, status: statusPatent } = usePatentStore();

    const [option, setOption] = useState("pedido");
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
    const [selectedComunas, setSelectedComunas] = useState<any[]>([]);
    const [selectedCustomer, setSelectedCustomer] = useState<string | null>(null);
    const [selectedOrders, setSelectedOrders] = useState<number[]>([]);
    const [processing, setProcessing] = useState<boolean>(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [facturedCount, setFacturedCount] = useState(0);
    const [progressAlertOpen, setProgressAlertOpen] = useState(false);

    const [selectedClient, setSelectedClient] = useState<Supplier | null>(null)
    const { status: statusSupplier, supppliers, getSuppliers } = useSupplierStore()

    const [dispatchGuides, setDispatchGuides] = useState<any[]>([]);
    const [drawerOpenRuta, setDrawerOpenRuta] = useState(false);

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState<any>(null);

    const [rutas, setRutas] = useState<any>([]);
    const [productosRuta, setProductosRuta] = useState<any>([]);
    const [selectedRuta, setSelectedRuta] = useState(null);


    const [routeModalOpen, setRouteModalOpen] = useState(false);
    const [routeDetails, setRouteDetails] = useState({
        patente: "",
        obs: "",
        conductor: "",
        fecha: localDate,
        hora: "",
    });

    const [openEmitModal, setOpenEmitModal] = useState(false);
    const [openDrawerInvoice, setOpenDrawerInvoice] = useState(false);
    const [emitOrderId, setEmitOrderId] = useState<number | null>(null);
    const [nInterno, setNInterno] = useState<string>("");
    const [ordenCompra, setOrdenCompra] = useState<string>("");
    const [isBulkEmit, setIsBulkEmit] = useState(false);


    const [allSelected, setAllSelected] = useState<boolean>(false);
    const [selectedTicket, setSelectedTicket] = useState<Ticket | null>(null)
    const [readOnly, setReadOnly] = useState<boolean>(false)
    const [showTrackerTicket, setShowTrackerTicket] = useState(false)
    const [pedidoSeleccionado, setPedidoSeleccionado] = useState<Ticket>()

    const [search, setSearch] = useState('')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const today = moment().format('YYYY-MM-DD')
    const oneYearAgo = moment().subtract(1, 'year').format('YYYY-MM-DD')


    const isClient: boolean = user?.userType === 'Cliente'

    const selectAllRows = () => {
        if (allSelected) {
            setSelectedOrders([]);
            setAllSelected(false);
        } else {
            const allIds = pedidos.map((pedido) => pedido.id);
            setSelectedOrders(allIds);
            setAllSelected(true);
        }
    };

    const isSelected = (row: any) => selectedOrders.some(selectedRow => selectedRow === row.id);

    useEffect(() => {
        getDataInitial()
    }, [])

    useEffect(() => {
        getPedidosAPI();
    }, [selectedDate, selectedComunas, selectedClient, option]);

    useEffect(() => {
        if (isClient && supppliers.length > 0) {
            const customer = supppliers.find((supplier) => supplier.rut === user?.supplier_rut);
            if (customer) {
                setSelectedClient(customer);
                setSelectedCustomer(customer.rut);
            } else {
                setSelectedClient(null);
                setSelectedCustomer(null);
            }
        }
    }, [isClient, supppliers])

    useEffect(() => {
        if (selectedClient?.id) {
            if (search != '') {
                const delayDebounce = setTimeout(() => {
                    getPedidosAPI()
                }, 1500)

                return () => clearTimeout(delayDebounce)
            } else {
                getPedidosAPI();
            }
        }
    }, [selectedClient, startDate, endDate, search])

    const getPedidosAPI = async () => {
        const filters: any = {};

        if (!selectedClient) return

        if (startDate) filters.start_date = startDate
        if (endDate) filters.end_date = endDate
        if (search) filters.search = search

        if (option === "pedido") {
            filters.status = 1;
            filters.types_document = [1, 2, 7];
        }

        const customer = supppliers.find((supplier) => supplier.rut === user?.supplier_rut);

        await getTicket({
            ...filters,
            iduser_created: user?.iduser_type === 3 ? user?.id : undefined,
            idcustomer: customer?.id,
            arr_status_invoice: [0, 1, 2]
        });
        setSelectedOrders([]);
        setAllSelected(false);
    };

    const handleOpenDrawer = (route: any) => {
        setSelectedRoute(route);
        setDispatchGuides(route.dispatch_guides.map((guide: any) => ({
            ...guide,
            details: guide.details.map((detail: any) => ({
                ...detail,
                productName: detail.ticket?.product?.name || "N/A",
            })),
        })));
        setDrawerOpenRuta(true);
    };


    const handleCloseDrawer = () => {
        setDrawerOpenRuta(false);
        setSelectedRoute({} as Route);
        setDispatchGuides([]);
    };

    const getDataInitial = async () => {
        await getSuppliers()
    }

    const getDistrictsAPI = async () => {
        await getDistricts()
    }

    const openRouteModal = () => setRouteModalOpen(true);

    const closeRouteModal = () => setRouteModalOpen(false);

    const handleRouteDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setRouteDetails((prev) => ({ ...prev, [name]: value }));
    };

    const handleRowDetails = (row) => {
        setReadOnly(true)
        setSelectedTicket(row)
        setSelectedOrder(row);
        handleSelectOrder(row)
        setOpenEmitModal(true)
        // setDrawerOpen(true);
    };

    const closeDrawer = () => {
        setDrawerOpen(false);
        setSelectedOrder(null);
        setSelectedOrders([])
    };

    const handleFacturar = async (row) => {
        setSelectedTicket(row)
        handleSelectOrder(row)
        setReadOnly(false)
        setEmitOrderId(row.id);
        setIsBulkEmit(false);
        setOpenEmitModal(true);
    };

    const handleGlobalFacturar = async () => {
        console.log(selectedOrders)
        if (selectedOrders.length === 0) return;
        setIsBulkEmit(true);
        setOpenEmitModal(true);
    };

    const confirmEmitOrder = async (references) => {
        setProcessing(true);
        const payload = { nInterno, ordenCompra, references };

        if (isBulkEmit) {
            for (const orderId of selectedOrders) {
                await createSalesDocument(orderId, payload);
            }
        } else {
            if (emitOrderId !== null) {
                const response = await createSalesDocument(emitOrderId, payload);
                if (response?.pdf) {
                    window.open(response.pdf, "_blank")
                }
            }
        }

        // Resetear estados y cerrar modal
        setProcessing(false);
        setOpenEmitModal(false);
        setNInterno("");
        setOrdenCompra("");
        setEmitOrderId(null);
        setSelectedOrders([]);
        await getPedidosAPI();
    };

    const confirmEmitOrders = async (orders: ProcessOrder[]) => {
        setProcessing(true);
        for (const order of orders) {
            const response = await createSalesDocument(order.ticket.id, {
                nInterno: order.nInterno,
                ordenCompra: order.ordenCompra,
                references: order.references,
            });
            if (response?.pdf) {
                window.open(response.pdf, "_blank")
            }
        }
        setProcessing(false);
        setOpenEmitModal(false);
        setSelectedOrders([])
        getPedidosAPI();
    };

    const clearDataRuta = async () => {
        setSelectedDriver({} as driver)
        setSelectedPatent({} as patent)
        setRouteDetails({
            patente: "",
            obs: "",
            conductor: "",
            fecha: localDate,
            hora: "",
        });
    }

    const handleGlobalRutear = async () => {

        const isEmptyObject = (obj: any) => {
            return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
        };

        if (!patentSelected || isEmptyObject(patentSelected) ||
            !driverSelected || isEmptyObject(driverSelected) ||
            !routeDetails.fecha) {
            alert("Todos los campos de la ruta son obligatorios.");
            return;
        }

        const facturadosIds = selectedOrders.filter((id) => {
            const order = pedidos.find((item) => item.id === id);
            return order;
        });

        if (facturadosIds.length === 0) {
            alert("No hay tickets facturados seleccionados para rutear.");
            return;
        }

        const formattedDate = moment(routeDetails.fecha).format("YYYY-MM-DD HH:mm:ss");

        let payload: any = {
            idsticket: facturadosIds,
            date: formattedDate,
            patente: patentSelected.name,
            driver: driverSelected.name,
            observations: routeDetails.obs,
        };

        await createRoute(payload)

        await getPedidosAPI()
        clearDataRuta()
    };


    const handleSelectOrder = (row) => {
        setSelectedOrders((prev) =>
            prev.includes(row.id) ? prev.filter((orderId) => orderId !== row.id) : [...prev, row.id]
        );
    };

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Tab") {
                event.preventDefault();

                setOption((prevOption) => {
                    const currentIndex = tabs.findIndex((tab) => tab.value === prevOption);
                    const nextIndex = (currentIndex + 1) % tabs.length;
                    return tabs[nextIndex].value;
                });
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);


    const handleWarehouseAction = async (warehouseId: number) => {
        try {
            const routeId = routeSelected.id
            const response = await TicketAPI.getDispatchPDF(routeId, warehouseId);
            const pdfURL = response?.url;
            window.open(pdfURL, '_blank');
        } catch (error) {
            console.error('Error al obtener el PDF:', error);
            alert('Ocurrió un error al intentar descargar el PDF. Por favor, intenta nuevamente.');
        }

    };

    const openInvoiceModal = (item) => {
        setSelectedRoute(item)
        setOpenDrawerInvoice(true);
    }

    const closeInvoiceModal = () => setOpenDrawerInvoice(false);

    const handleSeguimiento = (pedido) => {
        setPedidoSeleccionado(pedido)
        setShowTrackerTicket(true)
    }

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid
                item
                xs={12}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                }}
            >
                <Typography
                    sx={{
                        fontSize: "30px",
                        fontWeight: "600",
                        color: "#333",
                    }}
                >
                    MIS PEDIDOS
                </Typography>
            </Grid>

            <Grid item xs={12} mt={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} md={4}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Buscar"
                            variant="outlined"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4} md={4}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Fecha inicio"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                min: oneYearAgo,
                                max: today,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4} md={4}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Fecha fin"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                min: oneYearAgo,
                                max: today,
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                {option === "pedido" && (
                    <Grid container spacing={2}>
                        {pedidos.map((pedido) => (
                            <Grid item xs={12} sm={6} md={4} key={pedido.id}>
                                <Card
                                    sx={{
                                        borderRadius: 4,
                                        boxShadow: 4,
                                        overflow: 'hidden',
                                        transition: '0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.015)',
                                            boxShadow: 8,
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            p: 2,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            background: "#69ABC3",
                                            color: '#fff',
                                        }}
                                    >
                                        <Typography fontWeight={700} letterSpacing={0.5} textTransform="uppercase">
                                            Pedido #{pedido.nro_ticket}
                                        </Typography>
                                        <Chip
                                            label={"Seguir"}
                                            size="small"
                                            sx={{
                                                color: '#fff',
                                                background: 'rgba(255,255,255,0.2)',
                                                fontWeight: 500,
                                                padding: "8px 10px",
                                                '& .MuiChip-icon': {
                                                    color: '#fff',
                                                },
                                            }}
                                            icon={
                                                pedido.status === 'pedido' ? (
                                                    <Campaign fontSize="small" />
                                                ) : pedido.status === 'facturado' ? (
                                                    <DescriptionIcon fontSize="small" />
                                                ) : (
                                                    <SendIcon fontSize="small" />
                                                )
                                            }
                                            onClick={() => handleSeguimiento(pedido)}
                                        />
                                    </Box>

                                    <Box sx={{ p: 2.5 }}>
                                        <Typography variant="h6" fontWeight={600} gutterBottom>
                                            {pedido.name_customer}
                                        </Typography>

                                        <Typography variant="body2" color="text.secondary" gutterBottom>
                                            📍 <strong>Dirección:</strong> {pedido.district_customer}, {pedido.client_address}
                                        </Typography>

                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 1 }}>
                                            <Typography variant="body2" sx={{ color: '#555' }}>
                                                🗓️ <strong>Fecha:</strong> {moment(pedido.date).format('DD MMM YYYY')}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#555' }}>
                                                💵 <strong>Total:</strong> {moneyCL(pedido.total)}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{ my: 2 }} />

                                        <Box sx={{ minHeight: 100 }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                🛒 <strong>Productos</strong>
                                            </Typography>
                                            {pedido.details.slice(0, 3).map((prod, idx) => (
                                                <Typography
                                                    key={idx}
                                                    variant="body2"
                                                    noWrap
                                                    sx={{ color: '#444', fontSize: '0.875rem' }}
                                                >
                                                    - {prod.product} x{prod.amount}
                                                </Typography>
                                            ))}
                                            {pedido.details.length > 3 && (
                                                <Typography variant="caption" color="text.secondary">
                                                    +{pedido.details.length - 3} más
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>

                                    <Box
                                        sx={{
                                            px: 2.5,
                                            py: 1.5,
                                            backgroundColor: '#fafafa',
                                            borderTop: '1px solid #eee',
                                            textAlign: 'right',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.2s',
                                            '&:hover': {
                                                backgroundColor: '#f0f0f0',
                                            },
                                        }}
                                        onClick={() => handleRowDetails(pedido)}
                                    >
                                        <Typography variant="caption" color="primary">
                                            Ver detalles →
                                        </Typography>
                                    </Box>
                                </Card>

                            </Grid>
                        ))}
                    </Grid>
                )}
            </Grid>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity="success">
                    Facturado correctamente
                </Alert>
            </Snackbar>

            {progressAlertOpen && (
                <Box
                    sx={{
                        position: "fixed",
                        bottom: 16,
                        right: 16,
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        boxShadow: 4,
                        borderRadius: 2,
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        minWidth: "300px",
                    }}
                >
                    <Typography variant="body2">
                        {option === "pedido" && `Facturado ${facturedCount} de ${selectedOrders.length}`}
                        {option === "facturado" && `Enruteado ${facturedCount} de ${selectedOrders.length}`}
                    </Typography>

                </Box>
            )}

            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={closeDrawer}
                PaperProps={{
                    sx: {
                        width: 550,
                        backgroundColor: "#f9f9f9",
                        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                    },
                }}
            >
                <Box sx={{ p: 3 }}>
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontWeight: "bold", color: "#333" }}
                    >
                        Detalles del Pedido
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    {selectedOrder && (
                        <Box>
                            {/* Información principal del pedido */}
                            <Typography variant="body1" sx={{ mb: 1, display: 'block' }}>
                                <strong>Cliente:</strong> {selectedOrder.name_customer}
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 1, display: 'block' }}>
                                <strong>Dirección:</strong> {selectedOrder.client_address}
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 1, display: 'block' }}>
                                <strong>Fecha:</strong> {selectedOrder.date}
                            </Typography>

                            <Divider sx={{ my: 2 }} />

                            {/* Detalles de los productos */}

                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Producto</strong></TableCell>
                                            <TableCell align="center"><strong>Cant.</strong></TableCell>
                                            <TableCell align="center"><strong>Precio</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {(selectedOrder?.details || []).map((product, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{product.product}</TableCell>
                                                <TableCell align="center">
                                                    {product.amount}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {moneyCL(product.price)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Divider sx={{ my: 2 }} />

                            {/* Total del pedido */}
                            <Typography
                                variant="h6"
                                sx={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                    color: "#444",
                                }}
                            >
                                Total: {moneyCL(selectedOrder.total)}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Drawer>


            <Dialog open={routeModalOpen} onClose={closeRouteModal}>
                <DialogTitle>Detalles de la Ruta</DialogTitle>
                <DialogContent>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <Autocomplete
                            value={driverSelected ?? null}
                            options={drivers || []}
                            onChange={(e, value) => setSelectedDriver(value || {} as driver)}
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Buscar conductor"
                                    placeholder="Seleccione conductor"
                                    size="small"
                                    fullWidth
                                />
                            )}
                        />

                        <Autocomplete
                            value={patentSelected ?? null}
                            options={patents || []}
                            onChange={(e, value) => setSelectedPatent(value || {} as patent)}
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Buscar patente"
                                    placeholder="Seleccione patente"
                                    size="small"
                                    fullWidth
                                />
                            )}
                        />
                    </Box>

                    <TextField
                        label="Observaciones"
                        name="obs"
                        value={routeDetails.obs}
                        onChange={handleRouteDetailsChange}
                        fullWidth
                        margin="dense"
                    />
                    <TextField
                        label="Fecha y Hora"
                        name="fecha"
                        type="datetime-local"
                        value={routeDetails.fecha || localDate}
                        onChange={handleRouteDetailsChange}
                        fullWidth
                        margin="dense"
                        InputLabelProps={{ shrink: true }}
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        closeRouteModal();
                        clearDataRuta();
                    }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => {
                            closeRouteModal();
                            handleGlobalRutear();
                        }}
                        color="primary"
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            {
                selectedOrders.length > 0 && openEmitModal &&
                <IssueDrawer
                    openEmitModal={openEmitModal}
                    handleCloseDrawer={() => setOpenEmitModal(false)}
                    selectedTickets={selectedOrders.map(id => pedidos.find(pedido => pedido.id === id)).filter(Boolean) as Ticket[]}
                    confirmEmitOrders={confirmEmitOrders}
                    readOnly={readOnly}
                    setSelectedOrders={setSelectedOrders}
                    // confirmEmitOrder={confirmEmitOrder}
                    processing={processing}
                />
            }

            {showTrackerTicket && pedidoSeleccionado && (
                <TrackerTicketDrawer
                    open={showTrackerTicket}
                    onClose={() => setShowTrackerTicket(false)}
                    pedido={pedidoSeleccionado}
                />
            )}
        </Grid>

    );
};
